import { combineReducers } from 'redux'
import ScheduleByDateDivisionsDatetimesReducer from './schedule.bydate.divisions_datetimes.reducer'
import ScheduleByDateDivisionsDoctorsReducer from './schedule.bydate.divisions_doctors.reducer'

const ScheduleByDateReducer = combineReducers({
  divisions_datetimes: ScheduleByDateDivisionsDatetimesReducer,
  divisions_doctors: ScheduleByDateDivisionsDoctorsReducer,
})

export default ScheduleByDateReducer